module.exports = __webpack_public_path__ + "static/media/Team16.d4620e9b.png";